import type * as H from 'history';
import * as queryString from 'query-string';

export const CSV_EXPORT_QUERY_KEY = 'export';
export const CSV_EXPORT_QUERY_VALUE = 'true';

export const generateCsvExportModalOpenPathName = (location: Location): string => {
  const Url = new URL(location.href);
  const urlParams = new URLSearchParams(Url.search);
  urlParams.set(CSV_EXPORT_QUERY_KEY, CSV_EXPORT_QUERY_VALUE);
  Url.search = urlParams.toString();

  return `${Url.pathname}${Url.search}`;
};

export const isCsvExportModalOpen = (location: Location | H.Location): boolean => {
  return !!queryString.parse(location.search)?.export;
};
